var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(45.882353%,45.882353%,45.882353%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(45.882353%,45.882353%,45.882353%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 512 160 C 832 160 1024 512 1024 512 C 1024 512 832 864 512 864 C 192 864 0 512 0 512 C 0 512 192 160 512 160 Z M 512 224 C 286.666667 224 127.833333 432 75.166667 512 C 127.833333 591.833333 286.666667 800 512 800 C 737.333333 800 896.166667 592 948.833333 512 C 896.166667 432.166667 737.333333 224 512 224 Z M 512 288 C 635.666667 288 736 388.333333 736 512 C 736 635.666667 635.666667 736 512 736 C 388.333333 736 288 635.666667 288 512 C 288 388.333333 388.333333 288 512 288 Z M 512 352 C 423.666667 352.166667 352.166667 423.666667 352 512 C 352 600.166667 423.666667 672 512 672 C 600.333333 672 672 600.166667 672 512 C 672 423.833333 600.333333 352 512 352 Z M 512 352 ",
    transform: "matrix(0.0234375,0,0,0.0234375,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.982cc63db2eac3b508cde75c48533e26.svg";
export { ForwardRef as ReactComponent };